import React, { useCallback } from 'react';
import { isCollegeAnything } from '../../../../utils/transactions-util';
import { isAPP } from 'src/utils/advice/advice-utility';
import {
  SELL_ALL_SHARES_MODAL,
  SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS,
} from '../../../../redux/modules/modals/modals.module';
import { UNIT } from '../../../../settings/settings';
import Checkbox from '../../../Shared/Checkbox/Checkbox';
import './ConvertAllRemaining.scss';

import './RothConversionFundEditor.scss';
const ConvertAllRemaining = ({
  fund,
  checked,
  openModal,
  handleFundAllocations,
}) => {
  const { agreementID } = fund;

  /**
   * Click callback for Convert All remaining checkbox
   */
  const onConvertAllClick = useCallback(
    (checked) => {
      if (checked) {
        // will show user close fund alert on check
        let { openToNewInvestors } = fund;
        // 529 portfolios are all open to new investors.
        if (isCollegeAnything() || isAPP(fund.productType)) {
          openToNewInvestors = true;
        }
        openModal(
          openToNewInvestors
            ? SELL_ALL_SHARES_MODAL
            : SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS,
          { fund }
        );
      } else {
        handleFundAllocations(fund, {
          type: 'CLOSE ALL REMAINING',
          customProps: {
            closeout: false,
            grossUnit: UNIT.DOLLARS,
            grossAmountDollars: undefined,
            grossAmount: undefined,
          },
        });
      }
    },
    [fund, handleFundAllocations, openModal]
  );

  return (
    <div className="convertAllRemaining">
      <Checkbox
        id={`convert-all_${agreementID}`}
        checked={checked}
        onClick={onConvertAllClick}
        labelText={<span className="label-text">All Shares</span>}
      />
    </div>
  );
};

export default ConvertAllRemaining;
